import React, { useEffect, useState } from 'react';
import { Stack, Grid, FormControl, InputLabel, MenuItem, Select, Box} from '@mui/material';
import Brightness1Icon from '@mui/icons-material/Brightness1';

const CustomSeatLayout = ({layout=[]}) => {

  const [seatLayoutData, setSeatLayoutData] = useState([]);
  const [floors, setFloors] = useState([]);
  const [selectedFloor, setSelectedFloor] = useState('');

  const buildSeatLayout = (layoutData = {}) => {
    const  { columnCount, rowCount, librarySeats = [] } = layoutData;
    // const seats = [...librarySeats];
    const noOfColums = columnCount;
    const noOfRows = rowCount;
    const data = [];

    for(let row=0; row < noOfRows; row++) {
      const arrayIndex = row*noOfColums;
      const rowData = librarySeats.slice(arrayIndex,arrayIndex+noOfColums);
      data.push([...rowData]);
    }
    return data;
  }

  useEffect(() => {
    if(layout.length > 0) {

      // Set floors
      const  _floors = [];
      layout.forEach(floorObj => {
        _floors.push({label: floorObj.floor, val: floorObj.floor});
      });
      setFloors(_floors);
      setSelectedFloor(_floors[0].val)
    }
  }, [layout]);

  useEffect(() => {
    if(layout.length > 0) {

      const floorLayoutArr = layout.filter(({floor}) => floor === selectedFloor);
      const [floorLayout] = floorLayoutArr;

      const x = buildSeatLayout(floorLayout);
      setSeatLayoutData([...x]);
    }
  }, [selectedFloor, layout]);



  function buildSeatSourceUrl(seat) {
    let url = '/assets/images/desk-chair-black.svg';
    if(seat.booked) {
      url = '/assets/images/desk-chair.svg';
    }
    // if(selectedSeats.includes(seat.id)) {
    //   url = '/assets/images/desk-chair-yellow.svg';
    // }
    return url;
  }

  return (
    <Grid container columnSpacing={4} rowSpacing={2} >
      <Grid container item xs={12} sm={12} lg={12} md={12} rowSpacing={2} columnSpacing={0} direction="row"  alignItems="center" justifyContent="flex-start">
        <Grid container item xs={12} sm={12} lg={12} md={12} xl={12}  sx={{mb:1}} justifyContent="center">
          <Grid item xs={10} sm={5} lg={3} md={4} xl={2}  >
            <FormControl fullWidth>
              <InputLabel id="floor-select-label">Floor</InputLabel>
              <Select
                labelId="floor-select-label"
                label="Age"
                value={selectedFloor}
                onChange={(e) => setSelectedFloor(e.target.value)}
              >
                {floors.map(({label, val}) => <MenuItem key={val} value={val}>{label}</MenuItem>)}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} lg={12} md={12} xl={12} sx={{mb:4}}>
          <Stack spacing={2} direction="row">
            <Brightness1Icon sx={{color: "#000"}} /> Available
            <Brightness1Icon sx={{color: "#AAB1BA"}} /> Booked
            {/* {availableSeats ? <><Brightness1Icon color="primary" /> Selected</> : null} */}
          </Stack>
        </Grid>
        <Grid  sx={{margin:'0 auto', overflow: 'auto'}}>
          {seatLayoutData.map((row, i) => {
            return (
              <Grid key={i} sx={{textAlign: 'center', display: 'flex'}} >
                {row.map((seat, j) => (
                  // <Grid key={j} container item xs={6} sm={5} xl={3} lg={3} md={3} columnSpacing={3}  alignItems="center" justifyContent="center">
                  //   {column.map((seat, index) => (
                      <Grid key={j} stsxyle={{ width: '60px', padding: '2px', display: 'inline-block', textAlign: 'center', margin: '4px' }}>
                        <Box sx={{width: '60px',}}>
                         {seat?.hidden ? null : 
                          <>
                            <img
                              style={{width: '30px', height: '30px', padding: '2px', cursor: 'initial' }}
                              src={buildSeatSourceUrl(seat)}
                              alt={`Seat ${seat.name}`}
                              />
                              <p style={{margin: '0 0 12px 0'}}>
                                {seat.name}
                              </p>
                            </>
                          }
                        </Box>
                      </Grid>
                  //   ))}
                  // </Grid>
                ))}
              </Grid>
            )
          })}
        </Grid>
      </Grid>
    </Grid>
  );
}
 
export default React.memo(CustomSeatLayout);
